import {
  AccordionContent
} from "./chunk-AGIY7SFP.mjs";
import {
  AccordionHeader
} from "./chunk-MYVC3HMO.mjs";
import {
  AccordionItem
} from "./chunk-EZVEYJOX.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/accordion/accordion.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var Accordion = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className, indent = true } = _b, rest = __objRest(_b, ["children", "className", "indent"]);
    return /* @__PURE__ */ jsx(
      "div",
      __spreadProps(__spreadValues({}, rest), {
        className: clsx(
          "hds-accordion",
          !indent && "hds-accordion--no-indent",
          className
        ),
        ref,
        children
      })
    );
  }
);
Accordion.displayName = "Accordion";
Accordion.Item = AccordionItem;
Accordion.Header = AccordionHeader;
Accordion.Content = AccordionContent;

export {
  Accordion
};
//# sourceMappingURL=chunk-R6MQFVHE.mjs.map